export default __webpack_public_path__ + "static/media/028-wetsuit.06f782ec.svg";